import { usePermissions } from 'permissions';
import { Col, Row } from 'ui';
import { AdminUserDetailButton } from '../../../admin-user-detail-button';
import { EhrUserDetailButton } from '../../../ehr-user-detail-button';

type P = {
  memberId: string;
  nodeUserId?: string;
};

const MemberNavigationButtons = ({ memberId, nodeUserId }: P) => {
  const { canViewAdminDashboard, canViewEhrPortal } = usePermissions();

  const hasAdminPermission = canViewAdminDashboard({});
  const hasEhrPermission = canViewEhrPortal({});
  const actionSpan = hasAdminPermission && hasEhrPermission ? 12 : 24;

  if (!hasAdminPermission && !hasEhrPermission) {
    return null;
  }

  return (
    <Row gutter="xs">
      {hasAdminPermission ? (
        <Col span={actionSpan}>
          <AdminUserDetailButton block size="large" userId={memberId}>
            Admin console
          </AdminUserDetailButton>
        </Col>
      ) : null}
      {hasEhrPermission ? (
        <Col span={actionSpan}>
          <EhrUserDetailButton block size="large" userId={nodeUserId}>
            EHR Portal
          </EhrUserDetailButton>
        </Col>
      ) : null}
    </Row>
  );
};

export default MemberNavigationButtons;
